export enum ApiErrors {
  AssembleiaNaoIniciou = 'EVNOTINI01',
  AssembleiaEncerrada = 'EVNCLOSE01',
  PautaNaoLiberadaParaVotacao = 'PANOTOPN01',
  UsuarioSemAcesso = 'USNOTLOG01',
}